<template>
  <div class="layout expanded">
      <div class="container" :class="{[props.content_class]: true}" style="flex: 1 1 0%;">
          <slot name="content" />
      </div>
  </div>
</template>

<script setup>
  import {defineProps} from 'vue';

  const props = defineProps({
    content_class: {
      type    : String,
      default : null,
    },
  })
</script>